import { styled } from '@mui/material/styles';
var Svg = styled('svg')({
  verticalAlign: 'bottom'
});
export default Svg;